import { LocationData, LocationRecord } from "./Location"
import { StatusCode } from "./StatusCode"

export type TaskProp = {
    
}

export type TaskData = {
    locations: number[],
    displayName: string,
    routineTime: string,
    startFrom: number,
    days: number,
    taskType: TaskType
}

export type TaskResponse = {
    status: StatusCode,
    data: any
}

export type StartTask = {
    task_id: number,
    robot: number,
}

export type TaskLocationView = {
    displayName: string,
    map: number,
    location_id: number,
    sequence_id: number
}

export type TaskListData = {
    id: number,
    displayName: string,
    routineTime: string,
    days: number,
    locations: TaskLocationView[],
}

export enum TaskFrequency {
    NEVER = 0,
    WEEKLY,
    BIWEEKLY,
    MONTHLY
}

export enum TaskStatus {
    NONE = 0,
    COMPLETED,
    FAILED,
    IN_PROGRESS,
    UNASSIGNED,
    REQUEST_CANCELLED,
    QUEUED,
    ERROR,
    FAILED_LOCAL,
    ARRIVED,
    GOING_TO_CHARGE,
    CHARGING,
    CHARGE_COMPLETED,
    CHARGE_ABORT
}

export const rMapTaskStatus = {
    0: "None",
    1: "Completed",
    2: "Failed",
    3: "In Progress",
    4: "Unassigned",
    5: "Request Cancelled",
    6: "Queued",
    7: "Error",
    8: "Failed call job",
    9: "Waiting for interaction", // Can change to arrive
    10: "Going to charging station",
    11: "Charging",
    12: "Charge Completed",
    13: "Going to charge aborted"
}

export const rMapTaskType = {
    0: "Call Job",
    1: "Delivery Job",
}

export enum TaskType {
    SERVER_JOB = 0,
    LOCAL_JOB
}

export type TaskRecord = {
    id: number,
    robot: number,
    taskId: number,
    createdDatetime: string,
    completedDatetime: Date,
    assignedDatetime: Date,
    status: TaskStatus,
    path: LocationRecord[],
    taskType: TaskType,
    startFrom: LocationData,
}